import { render, staticRenderFns } from "./moreHistory.vue?vue&type=template&id=54b92346&scoped=true&"
import script from "./moreHistory.vue?vue&type=script&lang=js&"
export * from "./moreHistory.vue?vue&type=script&lang=js&"
import style0 from "./moreHistory.vue?vue&type=style&index=0&id=54b92346&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b92346",
  null
  
)

export default component.exports